import { isVector3 as r } from "./three/index15.js";
const c = (o) => r(o) ? o.toArray() : o;
export {
  c as Vector3toV3
};
//# sourceMappingURL=index10.js.map
